module.exports = "/shared/img/add-image.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/add-image.svg
// module id = 432
// module chunks = 13